import React, { useMemo } from 'react';
import { useMedia } from 'react-use-media';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components';

import Modal from '~/App/Components/Modal';

export interface CenteredModalProps {
  open: boolean;
  heading?: string;
  children: React.ReactNode;
  className?: string;
  loading?: boolean;
  width?: number | string;
  hideCloseButton?: boolean;
  onRequestClose: () => void;
}

export default function CenteredModal({
  open,
  heading = '',
  children,
  loading = false,
  width = 'auto',
  hideCloseButton = false,
  onRequestClose,
  className,
}: CenteredModalProps) {
  const isMobile = useMedia({
    maxWidth: 768,
  });

  const modalProps = useMemo(
    () => ({
      styles: {
        overlay: ({ base }) => ({
          ...base,
          display: 'flex',
          zIndex: 9990,
        }),
        content: ({ base }) => ({
          ...base,
          padding: 'unset',
          width: isMobile ? '100%' : width,
          margin: 'auto',
        }),
        panel: ({ base }) => ({
          ...base,
          maxWidth: '100%',
          position: 'relative',
          border: 'unset',
          overflow: 'hidden',
          margin: 'auto',
          borderRadius: 5,
          padding: 32,
        }),
      },
    }),
    [isMobile]
  );

  return (
    <Modal
      className={className}
      isOpen={open}
      onRequestClose={onRequestClose}
      hideActions
      isLoading={loading}
      {...modalProps}
    >
      {(heading || !hideCloseButton) && (
        <div className='flex items-center justify-end mb-5'>
          {heading && (
            <h1 className='my-0 mx-auto text-xl font-bold v2-text-neutral-900'>
              {heading}
            </h1>
          )}
          {!hideCloseButton && (
            <Button
              className='!p-0'
              variant={ButtonVariant.Icon}
              onClick={onRequestClose}
            >
              <i className='fal fa-times font-bold text-neutral-300 text-3xl' />
            </Button>
          )}
        </div>
      )}
      {children}
    </Modal>
  );
}
